import { render, staticRenderFns } from "./IconNotify.vue?vue&type=template&id=172cf268&scoped=true&"
import script from "./IconNotify.vue?vue&type=script&lang=js&"
export * from "./IconNotify.vue?vue&type=script&lang=js&"
import style0 from "./IconNotify.vue?vue&type=style&index=0&id=172cf268&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172cf268",
  null
  
)

export default component.exports